import React, { useState, useEffect } from 'react';

const DemoVerified = () => {
  const [timeLeft, setTimeLeft] = useState(10);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-2xl w-full p-8 bg-white rounded-lg shadow-lg">
        <div className="text-center">
          <div className="text-5xl text-green-500 mb-4">✓</div>
          <h1 className="text-3xl font-bold text-gray-800 mb-4">Your Discovery Call is Scheduled!</h1>

          <p className="text-lg text-gray-700 mb-6">
            Thanks for verifying your email address. A lifelike AI agent will now call you for a quick discovery conversation.
          </p>

          <div className="bg-gray-100 p-6 rounded-lg mb-6">
            <p className="font-semibold text-lg text-gray-800 mb-2">
              Keep your phone nearby – we’re calling now!
            </p>
            <p className="text-gray-700">
              Our AI agent will ask a few short questions to understand your business needs. This helps us tailor a personalized demo for you.
            </p>
          </div>

          <div className={`text-4xl font-mono font-bold mb-6 text-gray-800 ${timeLeft > 0 ? 'animate-pulse' : ''}`}>
            {timeLeft > 0 ? 
              `00:${timeLeft < 10 ? '0' + timeLeft : timeLeft}` : 
              "Calling now..."}
          </div>

          <p className="text-gray-700 mb-10">
            Please make sure to answer the call to get the most out of your personalized demo experience.
          </p>

          <div className="border-t border-gray-200 pt-6">
            <p className="text-gray-600">
              Have questions? Reach out anytime at <a href="mailto:info@lifelikeagents.com" className="text-blue-600 hover:underline">info@lifelikeagents.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoVerified;